/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HeroBannerSettingsImageWidth = "full" | "half" | "%future added value";
export type HpRespSharedHeroBanner_promoItem = {
    readonly cmsId: number | null;
    readonly imageUrl?: string | null;
    readonly imageHeight?: string | null;
    readonly imageWidth?: string | null;
    readonly mobileImageHeight?: string | null;
    readonly mobileImageWidth?: string | null;
    readonly mobileImageUrl?: string | null;
    readonly linkData: {
        readonly path: string | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_linkData">;
    };
    readonly heroBannerSettings: {
        readonly contentPosition: string | null;
        readonly backgroundColor: string | null;
        readonly bannerImageWidth: HeroBannerSettingsImageWidth | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_heroBannerSettings">;
    } | null;
    readonly cta: string | null;
    readonly isFullBleedImage: boolean | null;
    readonly format: CmsHomepageBannerFormatEnumType | null;
    readonly " $refType": "HpRespSharedHeroBanner_promoItem";
};
export type HpRespSharedHeroBanner_promoItem$data = HpRespSharedHeroBanner_promoItem;
export type HpRespSharedHeroBanner_promoItem$key = {
    readonly " $data"?: HpRespSharedHeroBanner_promoItem$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespSharedHeroBanner_promoItem">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespSharedHeroBanner_promoItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespHeroBannerText_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HeroBannerSettingsType",
      "kind": "LinkedField",
      "name": "heroBannerSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentPosition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerImageWidth",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespHeroBannerText_heroBannerSettings"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFullBleedImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageWidth",
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageUrl",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "PromoItem",
  "abstractKey": null
};
(node as any).hash = 'ca209e37ad7d6f175fec5ba992a7dc71';
export default node;
